import { gql } from '@apollo/client';

export const CREATE_MODEL_CONVERSATION = gql`
  mutation CreateModelConversation($modelId: String!, $partner: String!) {
    createModelConversation(modelId: $modelId, partner: $partner) {
      id
      modelId
      partner
      createdAt
      lastMessageAt
    }
  }
`;

export const CREATE_AGENT_CONVERSATION = gql`
  mutation CreateAgentConversation($agentName: String!, $partner: String!) {
    createAgentConversation(agentName: $agentName, partner: $partner) {
      id
      agentName
      partner
      createdAt
      lastMessageAt
    }
  }
`;

export const DELETE_CONVERSATION = gql`
  mutation DeleteConversation($id: String!) {
    deleteConversation(id: $id)
  }
`;

export const SEND_MODEL_MESSAGE = gql`
  mutation SendModelMessage(
    $conversationId: String!
    $message: String!
    $messages: [MessageInput!]!
    $modelId: String!
    $partner: String!
  ) {
    sendModelMessage(
      conversationId: $conversationId
      message: $message
      messages: $messages
      modelId: $modelId
      partner: $partner
    ) {
      role
      content
    }
  }
`;

export const SEND_AGENT_MESSAGE = gql`
  mutation SendAgentMessage(
    $conversationId: String!
    $message: String!
    $messages: [MessageInput!]!
    $agentName: String!
    $partner: String!
    $aliasName: String
    $aliasVersion: String
  ) {
    sendAgentMessage(
      conversationId: $conversationId
      message: $message
      messages: $messages
      agentName: $agentName
      partner: $partner
      aliasName: $aliasName
      aliasVersion: $aliasVersion
    ) {
      role
      content
      sessionId
      metadata
      resolvedAlias
      resolvedVersion
    }
  }
`;

export const GET_AGENTS = gql`
  query GetAgents {
    agentsList {
      id
      name
      description
      modelId
      capabilities
      status
      createdAt
      updatedAt
      agentArn
      agentId
      agentName
      agentVersion
      foundationModel
      promptOverrideConfiguration
      agentInstructions
      versionDetails
      clientToken
      customerEncryptionKeyArn
      knowledgeBases
      actionGroups
      agentResourceRoleArn
      idleSessionTTLInSeconds
      aliasId
      aliasName
      aliases {
        id
        name
        status
        description
      }
      agentStatus
      failureReasons
      sessionTimeout
    }
  }
`;

export const GET_ALIAS_DETAILS = gql`
  mutation GetAliasDetails($agentName: String!, $aliasName: String!) {
    getAliasDetails(agentName: $agentName, aliasName: $aliasName) {
      foundationModel
      agentInstructions
      aliasName
      aliasId
      agentVersion
      createdAt
      updatedAt
      guardrailConfiguration {
        guardrailIdentifier
        guardrailVersion
      }
    }
  }
`;
